import useTypedContext from "hooks/useTypedContext";
import useHasModuleWriteAccess from "shared/Module/access/useHasModuleWriteAccess";
import useHasStackWriteAccess from "shared/Stack/access/useHasStackWriteAccess";
import useIntelligenceSettings from "shared/Intelligence/useIntelligenceSettings";
import { Module, Stack } from "types/generated";
import { RunContext } from "components/Run/Context";

const isStack = (stack: Stack | Module): stack is Stack => (stack as Stack).__typename === "Stack";

const useRunSummary = () => {
  const { stack: stackOrModule } = useTypedContext(RunContext);
  const { canUseInfraAssistant } = useIntelligenceSettings();

  const hasStackWriteAccess = useHasStackWriteAccess();
  const hasModuleWriteAccess = useHasModuleWriteAccess();

  const canTriggerSummary = isStack(stackOrModule)
    ? hasStackWriteAccess(stackOrModule)
    : hasModuleWriteAccess(stackOrModule);

  return {
    canTriggerSummary,
    showSummarizerTrigger: canUseInfraAssistant,
  };
};

export default useRunSummary;
